var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.283,
    height: 20,
    viewBox: "0 0 28.283 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.283,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.685,3.111a3.553,3.553,0,0,0-2.5-2.516C22.98,0,14.138,0,14.138,0S5.3,0,3.091.595a3.553,3.553,0,0,0-2.5,2.516A37.267,37.267,0,0,0,0,9.961a37.267,37.267,0,0,0,.591,6.85,3.553,3.553,0,0,0,2.5,2.516c2.205.595,11.047.595,11.047.595s8.842,0,11.047-.595a3.553,3.553,0,0,0,2.5-2.516,37.267,37.267,0,0,0,.591-6.85,37.267,37.267,0,0,0-.591-6.85M11.246,14.165V5.757l7.39,4.2Z",
    transform: "translate(0 0.078)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWh);
export default __webpack_public_path__ + "static/media/youtube_wh.550f722652879a0b12775d213157505b.svg";
export { ForwardRef as ReactComponent };